export enum EquipmentHistoryItemType {
  Quotation,
  WorkOrder,
  ServiceCall
}
